export default "__VITE_ASSET__Bp5xN9Af__"